import Bookings from './Bookings';

export default Bookings;
